module.exports = __webpack_public_path__ + "static/media/report2.ef6b059a.pdf";